import { render, staticRenderFns } from "./UserSecurityLog.vue?vue&type=template&id=066026ae&scoped=true&"
import script from "./UserSecurityLog.vue?vue&type=script&lang=js&"
export * from "./UserSecurityLog.vue?vue&type=script&lang=js&"
import style0 from "./UserSecurityLog.vue?vue&type=style&index=0&id=066026ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066026ae",
  null
  
)

export default component.exports